import { useSyncExternalStore } from "react";

const query = "(min-width: 1024px) and (min-height: 760px) and (prefers-reduced-motion: no-preference)";
const subscribe = (notify) => {
  const media = window.matchMedia(query);
  media.addEventListener("change", notify);
  return () => media.removeEventListener("change", notify);
};

export default function useScrollStage() {
  return useSyncExternalStore(subscribe, () => window.matchMedia(query).matches, () => false);
}
